import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChevronRightMdLine = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "currentColor",
	id: "svg1",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { id: "defs1" }), /* @__PURE__ */ _jsx("path", {
		id: "path2",
		d: "m 10,7.25 c -0.1919336,0 -0.3848051,0.072305 -0.53125,0.21875 -0.2928897,0.2928897 -0.2928897,0.7696103 0,1.0625 L 12.939453,12 9.46875,15.46875 c -0.2928897,0.2929 -0.2928897,0.7696 0,1.0625 0.2928897,0.2929 0.7696,0.2929 1.0625,0 l 4,-4 c 0.2929,-0.2929 0.2929,-0.7696 0,-1.0625 l -4,-4 C 10.3848,7.3223051 10.191934,7.25 10,7.25 Z"
	})]
});
export default SvgChevronRightMdLine;
